// extracted by mini-css-extract-plugin
export var container = "contactInfo-module--container--3IulN";
export var box = "contactInfo-module--box--1zNYH";